if (!customElements.get('quantity-input')) {
class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.product = this.closest('[data-product]');
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }

    if (this.product) {
      const productQuantityInput = this.product.querySelector('product-form input[name="quantity"]');

      if (!productQuantityInput) { return; }

      productQuantityInput.value = this.input.value;
    }
  }
}

customElements.define('quantity-input', QuantityInput);
}